import script from "./PartnerLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerLayout.vue?vue&type=script&setup=true&lang=js"

import "./PartnerLayout.vue?vue&type=style&index=0&id=3fbb6ed4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbb6ed4"]])

export default __exports__